// extracted by mini-css-extract-plugin
export default {"root":"styles__root___sqURO"};